module.exports = __webpack_public_path__ + "img/26-dodge-charger.c9a12929.jpg";